module.exports = "/assets/data/ebe317175af4a4d6c6c31ad9d5b920ed-RM13.data.json";